import React from 'react';
const Hero = () => {
  return <div className="mt-6" id="introduction" data-id="element-89">
      <div className="relative mb-1" data-id="element-90">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uty9i8NFUFDfqnngEfSqsn/1350.png" alt="Diagram of knee with Baker's cyst" className="w-full h-auto rounded-lg shadow-lg" data-id="element-91" />
      </div>
      <div className="prose prose-xl max-w-none" data-id="element-92">
        <p className="mb-6 text-xl text-gray-800 leading-relaxed first-letter:text-6xl first-letter:font-bold first-letter:text-green-600 first-letter:mr-2 first-letter:float-left" data-id="element-93">
          The alarm goes off at 6:30 AM, but Susan M. has been awake since 4 –
          again. The throbbing in her knees simply won't let her sleep.
        </p>
        <p className="mb-6 text-xl text-gray-800 leading-relaxed" data-id="element-94">
          As the 52-year-old former marathon runner grips her nightstand and
          bites her lip to keep from crying out, she thinks about her
          granddaughter Emma's birthday party last month.
        </p>
        <div className="bg-green-50 border-l-4 border-green-500 p-6 my-8 rounded-r-lg" data-id="element-95">
          <p className="italic text-xl text-gray-800" data-id="element-96">
            "I was only 52, but I felt like I was 82," Susan recalls. "And my
            doctor's next suggestion was knee replacement surgery."
          </p>
        </div>
        <p className="mb-6 text-xl text-gray-800 leading-relaxed" data-id="element-97">
          The one where she sat in a lawn chair while Emma's other grandmother
          played with the kids.
        </p>
      </div>
    </div>;
};
export default Hero;